import { gql } from '@apollo/client'

export type QueryVars = {
  customerId: string
  limit: number
  offset: number
}

export type Squad = 'a' | 'b' | 'c' | 'd' | 'e' | 'g' | 'i' | 'j' | 'k' | 'l'

export type ExecutiveResponse = {
  userId: string
  skillLevel: number | null
  squads: Squad[]
  fullName: string
}

export type Response = {
  getExecutives: {
    total: number
    offset: number
    results: ExecutiveResponse[]
  }
}

const query = gql`
  query ($customerId: String!, $limit: Int!, $offset: Int!) {
    getExecutives(customerId: $customerId, limit: $limit, offset: $offset) {
      total
      offset
      results {
        userId
        skillLevel
        squads
        fullName
      }
    }
  }
`

export default query
